<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="home">Home</a>
                </span>
                IMPOSTAZIONI GENERALI
            </div>
        </div>    
        
        <div class="tab-cont p-4" id="style-3">
            <div class="container-fluid text-start">
                
                <!-- Giorni di chiusura -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white">Giorni di chiusura settimanale</div>
                    <div class="card-body">
                        <div class="d-flex flex-wrap gap-3">
                            <div class="form-check" v-for="(giorno, index) in giorniSettimana" :key="index">
                                <input class="form-check-input" type="checkbox" :value="index" :id="'giorno-'+index" v-model="settings.giorniChiusura">
                                <label class="form-check-label" :for="'giorno-'+index">
                                    {{ giorno }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Ferie -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white d-flex justify-content-between align-items-center">
                        Ferie
                        <button class="btn btn-sm btn-light" @click="addFerie">+ Aggiungi Periodo</button>
                    </div>
                    <div class="card-body">
                        <table class="table" v-if="settings.ferie.length > 0">
                            <thead>
                                <tr>
                                    <th>Da</th>
                                    <th>A</th>
                                    <th>Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(periodo, i) in settings.ferie" :key="i">
                                    <td><input type="date" class="form-control" v-model="periodo.da"></td>
                                    <td><input type="date" class="form-control" v-model="periodo.a"></td>
                                    <td>
                                        <button class="btn btn-danger btn-sm" @click="removeFerie(i)">Rimuovi</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-else class="text-muted mb-0">Nessun periodo di ferie inserito.</p>
                    </div>
                </div>

                <!-- Piattaforme Delivery -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white d-flex justify-content-between align-items-center">
                        Piattaforme Delivery
                        <button class="btn btn-sm btn-light" @click="addDelivery">+ Aggiungi Piattaforma</button>
                    </div>
                    <div class="card-body">
                        <table class="table align-middle" v-if="settings.delivery && settings.delivery.length > 0">
                            <thead>
                                <tr>
                                    <th>Nome Piattaforma</th>
                                    <th>Commissione Ordine (%)</th>
                                    <th>Quota Fissa (€)</th>
                                    <th style="width: 100px;">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(piattaforma, i) in settings.delivery" :key="i">
                                    <td>
                                        <input type="text" class="form-control" v-model="piattaforma.nome" placeholder="es. JustEat, UberEats" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="number" step="0.01" min="0" class="form-control" v-model.number="piattaforma.percentuale" placeholder="0" />
                                            <span class="input-group-text">%</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="number" step="0.01" min="0" class="form-control" v-model.number="piattaforma.quotaFissa" placeholder="0" />
                                            <span class="input-group-text">€</span>
                                        </div>
                                    </td>
                                    <td>
                                        <button class="btn btn-danger btn-sm" @click="removeDelivery(i)">Rimuovi</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-else class="text-muted mb-0">Nessuna piattaforma di delivery inserita.</p>
                    </div>
                </div>

                <!-- Stripe -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white">Configurazione Stripe (Pagamenti)</div>
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="form-label">Stripe Secret Key</label>
                            <input type="password" class="form-control" v-model="settings.stripeSecretKey" placeholder="sk_test_..." />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Stripe Webhook Secret</label>
                            <input type="password" class="form-control" v-model="settings.stripeWebhookSecret" placeholder="whsec_..." />
                        </div>
                    </div>
                </div>

                <!-- Coperto -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white">Costo Coperto</div>
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="form-label">Importo (€)</label>
                            <input type="number" step="0.50" min="0" class="form-control" v-model="settings.costoCoperto" />
                        </div>
                    </div>
                </div>
                <!-- Password Admin -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white">Password Amministratore</div>
                    <div class="card-body">
                        <div class="mb-3 text-start">
                            <label class="form-label">Password Admin (per eliminare piatti e tavoli)</label>
                            <input type="password" class="form-control" v-model="settings.passwordAdmin" placeholder="Inserisci password admin" />
                        </div>
                    </div>
                </div>
                <!-- Scontrino Elettronico -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white d-flex justify-content-between align-items-center">
                        Scontrino Elettronico
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="isActive" v-model="settings.scontrinoElettronico.isActive">
                            <label class="form-check-label text-white ms-2" for="isActive">Attivo</label>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mb-3 text-start">
                            <label class="form-label">API Key</label>
                            <input type="password" class="form-control" v-model="settings.scontrinoElettronico.apiKey" placeholder="Inserisci API Key" />
                        </div>
                        <div class="mb-3 text-start">
                            <label class="form-label">Password</label>
                            <input type="password" class="form-control" v-model="settings.scontrinoElettronico.password" placeholder="Inserisci Password" />
                        </div>
                    </div>
                </div>

                <!-- Dati Azienda (per Fatturazione) -->
                <div class="card mb-4">
                    <div class="card-header fw-bold bg-dark text-white">Dati Azienda (per Fatturazione)</div>
                    <div class="card-body">
                        <div class="row text-start" style="color: black;">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Denominazione (Ragione Sociale) *</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.denominazione" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Partita IVA *</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.pIva" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Codice Fiscale</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.codFiscale" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Regime Fiscale (es. RF01) *</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.regimeFiscale" placeholder="RF01" />
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label">Indirizzo *</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.indirizzo" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">CAP *</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.cap" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Comune *</label>
                                <input type="text" class="form-control" v-model="settings.datiAzienda.comune" />
                            </div>
                            <div class="col-md-2 mb-3">
                                <label class="form-label">Provincia *</label>
                                <input type="text" class="form-control" maxlength="2" v-model="settings.datiAzienda.provincia" />
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="text-end">
                    <button class="btn btn-success btn-lg" @click="saveSettings">Salva Impostazioni</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
    name: 'Impostazioni',
    data() {
        return {
            store,
            settingsId: '69c90e57851daafaf559b837',
            giorniSettimana: [
                'Domenica', 
                'Lunedì', 
                'Martedì', 
                'Mercoledì', 
                'Giovedì', 
                'Venerdì', 
                'Sabato'
            ],
            settings: {
                giorniChiusura: [],
                ferie: [],
                delivery: [],
                stripeSecretKey: '',
                stripeWebhookSecret: '',
                passwordAdmin: '',
                scontrinoElettronico: {
                    isActive: false,
                    apiKey: '',
                    password: ''
                },
                costoCoperto: 0,
                datiAzienda: {
                    denominazione: '',
                    pIva: '',
                    codFiscale: '',
                    regimeFiscale: 'RF01',
                    indirizzo: '',
                    cap: '',
                    comune: '',
                    provincia: ''
                }
            }
        }
    },
    methods: {
        home() {
            this.$router.push({ name: "Gestionale"})
        },
        addFerie() {
            this.settings.ferie.push({ da: '', a: '' });
        },
        removeFerie(index) {
            this.settings.ferie.splice(index, 1);
        },
        addDelivery() {
            if (!this.settings.delivery) {
                this.settings.delivery = [];
            }
            this.settings.delivery.push({ nome: '', percentuale: 0, quotaFissa: 0 });
        },
        removeDelivery(index) {
            this.settings.delivery.splice(index, 1);
        },
        formatDateForInput(dateString) {
            if (!dateString) return '';
            const d = new Date(dateString);
            return d.toISOString().split('T')[0];
        },
        getSettings() {
            this.axios.get(this.store.path + 'impostazioni/' + this.settingsId, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                const data = response.data;
                if (data) {
                    const newSettings = {
                        giorniChiusura: data.giorniChiusura || [],
                        ferie: [],
                        delivery: data.delivery && Array.isArray(data.delivery) ? data.delivery.map(d => ({
                            nome: d.nome || '',
                            percentuale: d.percentuale !== undefined && d.percentuale !== null ? Number(d.percentuale) : 0,
                            quotaFissa: d.quotaFissa !== undefined && d.quotaFissa !== null ? Number(d.quotaFissa) : 0
                        })) : [],
                        stripeSecretKey: data.stripeSecretKey || '',
                        stripeWebhookSecret: data.stripeWebhookSecret || '',
                        passwordAdmin: data.passwordAdmin || '',
                        scontrinoElettronico: data.scontrinoElettronico ? {
                            isActive: data.scontrinoElettronico.isActive || false,
                            apiKey: data.scontrinoElettronico.apiKey || '',
                            password: data.scontrinoElettronico.password || ''
                        } : {
                            isActive: false,
                            apiKey: '',
                            password: ''
                        },
                        costoCoperto: data.costoCoperto !== undefined ? data.costoCoperto : 0,
                        datiAzienda: data.datiAzienda || {
                            denominazione: '',
                            pIva: '',
                            codFiscale: '',
                            regimeFiscale: 'RF01',
                            indirizzo: '',
                            cap: '',
                            comune: '',
                            provincia: ''
                        }
                    };
                    
                    if (data.ferie && Array.isArray(data.ferie)) {
                        newSettings.ferie = data.ferie.map(f => ({
                            da: this.formatDateForInput(f.da),
                            a: this.formatDateForInput(f.a)
                        }));
                    }
                    this.settings = newSettings;
                }
            }).catch(error => {
                console.error("Errore nel caricamento delle impostazioni:", error);
            });
        },
        saveSettings() {
            this.axios.post(this.store.path + 'impostazioni/' + this.settingsId, this.settings, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(() => {
                alert("Impostazioni salvate con successo!");
            }).catch(error => {
                console.error("Errore salvataggio impostazioni:", error);
                alert("Errore durante il salvataggio.");
            });
        }
    },
    beforeMount() {
        this.getSettings();
    }
}
</script>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    height: 100vh;
}
.con-sal {
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: bold;
}
.nav-sale{
    flex-basis: 15vh;
}

.tab-cont {
    margin: auto;
    background: #F5F5F5;
    overflow-y: scroll;
    flex-basis: 80%;
    width: 100vw;
}

#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #000000;
}
</style>
